import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import requestClient from '../../utils/requestClient';
import ArticleCard from '../../components/Elements/Cards/ArticleCard';
import SuccessMessage from '../../components/Elements/SuccessMessage';

const ResourceList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [successMessage, setSuccessMessage] = useState(null);

    useEffect(() => {
        async function getData() {
            const response = await requestClient().get(`/api/v2/employer/resources/`)

            setData(response.data.data)
        }
        getData();
    }, []);

    useEffect(() => {
        // Check for success message from navigation state
        if (location.state && location.state.successMessage) {
            setSuccessMessage(location.state.successMessage);
            
            // Clear the navigation state to prevent showing message on refresh
            navigate(location.pathname, { replace: true, state: null });
            
            // Clear the success message after showing it
            setTimeout(() => setSuccessMessage(null), 5000);
        }
    }, [location.state, location.pathname, navigate]);

    return (data ?
        <main>
            <section className="bg-white">
                <div className='container py-8 lg:py-12'>
                    <div className='border-b pb-8 flex lg:items-center lg:justify-between mb-8 gap-4 flex-col lg:flex-row'>
                        <h1>Resources</h1>
                        <div className='flex relative overflow-hidden pl-[40px] flex lg:w-auto'>
                            <a href="/employer/resources/create">
                                <button className='btn btn-invert w-full lg:w-auto'>Create</button>
                            </a>
                        </div>
                    </div>
                    { successMessage ? <SuccessMessage title="Success" text={successMessage} className="mb-4" /> : null }
                    <div className='grid gap-8 lg:grid-cols-3'>
                        {data.map((article, index) => (
                            <ArticleCard key={index} item={article} isEmployer={true} />
                        ))}
                    </div>
                </div>
            </section>
        </main>
        : null);
};

export default ResourceList;
